import { Link } from "react-router-dom";
import classNames from "./BackToHome.module.css";
import { IoArrowBack } from "react-icons/io5";

const BackToHome = () => {
  return (
    <Link to="/" className={classNames.BackToHome}>
      <IoArrowBack /> Back to home
    </Link>
  );
};

export default BackToHome;
